"use client"

import { useEffect, useState } from "react"
import { Crown } from "lucide-react"

/**
 * Live "N of 100 free-Pro spots left" badge. Renders nothing while loading,
 * on error, or once the founding offer is full (remaining <= 0).
 */
export function FoundingSpotsBadge({ className = "" }: { className?: string }) {
  const [data, setData] = useState<{ remaining: number; cap: number } | null>(null)

  useEffect(() => {
    let active = true
    fetch("/api/founding/status")
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (active) setData(d) })
      .catch(() => {})
    return () => { active = false }
  }, [])

  if (!data || data.remaining <= 0) return null

  return (
    <div className={`inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 text-xs font-semibold px-3 py-1.5 rounded-full ${className}`}>
      <Crown size={12} />
      Founding offer — {data.remaining} of {data.cap} free Pro spots left
    </div>
  )
}
